// on import un fichier css vide pour sassurer que le fichier dist/source.css est bien builder
import './vparcel.parcel.css'

// ugly hack to make debounce available in globalThis
import { debounce } from "/vodalys/.jslibs/";
globalThis.debounce = debounce

if (process.env.NODE_ENV === 'development') {


    async function checkHrm() {
        const ws = new WebSocket('ws://localhost:1234')
        try {
            await new Promise(resolve => setTimeout(resolve, 1000))
            if (ws.readyState === 1) {
                globalThis.hmr = true
                console.info('hmr is enabled')

                // search for #hmrStatus element and remove it
                const hmrStatus = document.getElementById('hmrStatus')
                hmrStatus && hmrStatus.remove()

                // add a div to the body to display the hmr status
                const div = document.createElement('div')
                div.id = 'hmrStatus'

                div.style.position = 'fixed'
                div.style.bottom = '0'
                div.style.right = '0'
                // use a delete custor style
                div.style.cursor = 'pointer'



                // remove the div on click
                div.onclick = () => {
                    div.remove()
                }

                const span = document.createElement('span')
                span.style.padding = '5px'
                span.style.backgroundColor = 'rgba(0, 138, 30, 0.5)'
                span.style.color = 'white'
                span.style.fontFamily = 'monospace'
                span.style.fontSize = '12px'
                span.style.borderRadius = '5px 5px 0 0'
                span.style.margin = '5px'

                // span.style.display = 'none'

                span.innerText = 'HMR 🚀'

                div.appendChild(span)
                document.body.appendChild(div)


            } else {
                globalThis.hmr = false
                console.info('hmr is disabled')
            }
        } finally {
            ws.close()
        }
    }

    checkHrm()


}
